module.exports = "/images/Vector.svg";